// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rJXhLoXiVx_0PP {
  max-width: 1250px;
  margin: 0 auto 24px auto;
  padding: 12px 0;
}
.rJXhLoXiVx_0PP.Gonq8iuch1TJCU {
  max-width: unset;
}
.zFmPLjFjbS85J7 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.oa4owxzJKsbQhS {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.oa4owxzJKsbQhS .a53JaLbYrxkPBG {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}
.oa4owxzJKsbQhS h2 {
  margin: 0;
}
.jO8Tt4BbZFwIiy {
  color: var(--ds-text-subtle, #44546f);
}
.q512gtqrYVq6rW {
  display: flex;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  transition: background 0.2s ease;
  background: transparent;
}
.q512gtqrYVq6rW:hover {
  background: transparent;
}
.w9cujdVisxLi4V {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 24px;
}
.w9cujdVisxLi4V.DYa7oBoskhB2ln {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin: 24px 0 36px;
  column-gap: 16px;
  row-gap: 16px;
}
@media only screen and (max-width: 1280px) {
  .w9cujdVisxLi4V.DYa7oBoskhB2ln {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media only screen and (max-width: 750px) {
  .w9cujdVisxLi4V.DYa7oBoskhB2ln {
    grid-template-columns: 1fr;
  }
}
.iyXzggyw4nK5o0 a {
  color: var(--ds-link, #0c66e4);
}
.tHa2YUALa9NO4V {
  display: inline-block;
  width: 240px;
  min-width: 200px;
  vertical-align: middle;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `rJXhLoXiVx_0PP`,
	"fullscreen": `Gonq8iuch1TJCU`,
	"headerRow": `zFmPLjFjbS85J7`,
	"iconHeaderContainer": `oa4owxzJKsbQhS`,
	"templateBoardIcon": `a53JaLbYrxkPBG`,
	"subheader": `jO8Tt4BbZFwIiy`,
	"dismissButton": `q512gtqrYVq6rW`,
	"templatesContainer": `w9cujdVisxLi4V`,
	"modernized": `DYa7oBoskhB2ln`,
	"templateGalleryLink": `iyXzggyw4nK5o0`,
	"categorySelector": `tHa2YUALa9NO4V`
};
export default ___CSS_LOADER_EXPORT___;
